<template>
  <!-- マイタスク「勤怠確認」タブ -->
  <div class="kintai-check-staff-list">

    <template v-if="isLoading">
      <template v-if="!isInit || !isError">
        <loading :message="'データ読み込み中...'"></loading>
      </template>
    </template>

    <template v-else>
      <div class="baseinfo">
        <div class="control">
          <div>
            <span>選択したスタッフのタイムシートを表示します</span>
          </div>

          <div>
            <nav>

              <div v-for="(group, gIndex) in form">
                <span>{{ group.group_name }}</span>
                <br>
                <ul>
                  <li class="item" v-for="(staff, index) in group.group_users">
                    <div v-on:click="showStaffKinmu(gIndex, index)">
                      <span>{{ staff.staff_name }}</span>
                    </div>
                  </li>
                </ul>
              </div>

            </nav>
          </div>
        </div>
      </div>
    </template>


  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, Ref, ref, computed } from 'vue';
import { dateFormat, dateFormatMMDD, timeFormat } from "@/filters/common";
import { useInit } from '@/composable/mytask/staff/init';
import { useRouter } from 'vue-router';
import { RouterConst } from '@/const/Router';
import { useMyTaskCommonStore } from '@/store/mytask-common';

export default defineComponent({
  props: ['options', 'tab'],
  setup(props) {

    const isInit = ref(false);

    // 初期化
    const { isLoading, isError, form } = useInit();
    const router = useRouter();

    onMounted(async () => {

    });

    // 選択したスタッフの勤務リストを表示する
    const showStaffKinmu = ((gIndex: number, index: number) => {
      let group = form.value[gIndex];
      let selectedStaff = form.value[gIndex].group_users[index];

      // MEDICA_AS-1308対応 年月指定のない画面のため、server側で年月の判断をするようにnullを引数で渡す
      // 勤務一覧の年月指定用
      // let year = ref(new Date().getFullYear()); // 初期値として現在の西暦をセット
      // let month = ref(new Date().getMonth() + 1); // 初期値として現在の月をセット

      router.push(
        {
          name: RouterConst.KINMU_LIST
          , query: {
            targetUserId: selectedStaff.user_id,
            targetSyouninGroupId: group.mst_syounin_group_id,
            from: RouterConst.MY_TASK,
            year: null,
            month: null,
            // year: year.value,
            // month: month.value,
          }
        }
      );
    });

    return {
      isLoading,
      isError,
      isInit,
      form,
      dateFormat,
      dateFormatMMDD,
      timeFormat,
      RouterConst,
      showStaffKinmu,
    }
  },
  components: {

  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/mytask-kinta-check-staff-list.scss';
</style>
